/* unplugin-vue-components disabled */import script from "./FlowPercentage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlowPercentage.vue?vue&type=script&setup=true&lang=ts"

import "./FlowPercentage.vue?vue&type=style&index=0&id=cb4ab8ba&lang=less&scoped=true"

import exportComponent from "/layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb4ab8ba"]])

export default __exports__